import dayjs from 'dayjs'
import { DATE_FORMAT } from './constants'
import { toNumber } from './utils'


export const round2 = (value) => Math.round(toNumber(value) * 100) / 100

let rowId = 0
const makeRow = (date, amount) => ({
	key: `ins-${++rowId}`,
	date,
	amount: round2(amount),
})

export const scheduleTotal = (rows) =>
	round2(rows.reduce((sum, row) => sum + toNumber(row.amount), 0))


export const buildSchedule = ({
	months,
	startDate,
	total,
	firstPayment,
	percent = 0,
}) => {
	const count = Math.max(1, Math.floor(toNumber(months)))
	const start = startDate && startDate.isValid?.() ? startDate : dayjs()
	const paid = round2(firstPayment)
	const rest = round2(
		Math.max(0, toNumber(total) - paid) * (1 + toNumber(percent) / 100),
	)
	const monthly = round2(rest / count)

	const rows = [makeRow(start.format(DATE_FORMAT), paid)]
	for (let i = 1; i <= count; i += 1) {
		rows.push(makeRow(start.add(i, 'month').format(DATE_FORMAT), monthly))
	}

	const diff = round2(paid + rest - scheduleTotal(rows))
	if (diff !== 0) {
		const last = rows[rows.length - 1]
		last.amount = round2(last.amount + diff)
	}
	return rows
}

export const spreadAmountFrom = (rows, index, amount) =>
	rows.map((row, i) =>
		i >= index && i > 0 ? { ...row, amount: round2(amount) } : row,
	)

export const setAmountAt = (rows, index, amount) =>
	rows.map((row, i) => (i === index ? { ...row, amount: round2(amount) } : row))

export const shiftDatesFrom = (rows, index, date) => {
	if (!date?.isValid?.()) return rows
	return rows.map((row, i) =>
		i < index
			? row
			: { ...row, date: date.add(i - index, 'month').format(DATE_FORMAT) },
	)
}

export const toInstallmentsPayload = (rows) =>
	rows
		.filter((row) => toNumber(row.amount) > 0)
		.map((row) => ({ total: round2(row.amount), dueDate: row.date }))
